export const paths = {
  home: "/",
  campaignDetails: "/campaign-details/:id",
  articleDetails: "/article-details/:id",
  auth: "/auth",
};
